import styles from './ProductListing.module.scss';
import { Grid, Typography } from '@mui/material';
import ProductCard from '../../../../commons/components/ui/Cards/ProductCard/ProductCard';
import { showcaseProducts } from '../../homepage/ProductShowCase/constants';

export default function ProductListing() {
  return (
    <div className={styles.productListingWrapper}>
      <div className={styles.productListingContainer}>
        <div className={styles.productListingContent}>
          <div className={styles.productListingTitleConent}>
            <Typography variant="h5" color="primary.black">
              Shop All Products
            </Typography>
            <Typography variant="h1" color="primary.main">
              Find the Solutions to Solve Your Problems.
            </Typography>
          </div>
          <div className={styles.productListingMainContainer}>
            <Grid
              container
              justifyContent={{ sm: 'space-around', xl: 'flex-start' }}
            >
              {Object.values(showcaseProducts).map((item) => (
                <Grid item xl={3} lg={3}>
                  <ProductCard
                    {...item}
                    badge={item.title === 'Think Factor' ? 'New Arrival!' : ''}
                    variantKey={item.variantKey}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
}
